import React, { useEffect, useState, useRef} from "react";
import store from "@/redux/store";
import { useNavigate, Link } from "react-router-dom";

import { BuildingOfficeIcon, CreditCardIcon, UserIcon, UsersIcon, DocumentIcon } from '@heroicons/react/20/solid'
import { Profile } from "@/views/base/user/Profile";
import { Pavillion } from "@/views/base/user/Pavillion";
import { useForm, SubmitHandler, Controller } from "react-hook-form"
import  {IUser} from "@/models/User";
import  {IAddress} from "@/models/interfaces";

type props = IUser | IAddress

export function AdminUserDetail({...props}) {
    const roleDetailView = useRef(null); 
const [selectedTab, setSelectedTab] = useState(1)
let saveWith = false;

  const { register, handleSubmit, watch, reset, control, setValue, getValues, formState } = useForm<props>({
      defaultValues: props.userfields
    })
   const onSubmit = (data) => {
       
       props.onSaveHandler(props?.selectedId, data);
      }


const tabs = [


  {tabId: 1,  name: 'Paviljoen rechten', href: '#', icon: UserIcon, current: true },
//  { name: 'Bedrijf', href: '#', icon: BuildingOfficeIcon, current: false },
//  { name: 'Billing', href: '#', icon: CreditCardIcon, current: false },
]  // More people...

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const setTab = (tabId) => {
    
    setSelectedTab(tabId);
    }


  const onSaveWrapped = (data) => {
    event.preventDefault();
    event.stopPropagation();
        data.rights = props.userRoles.selected;
    if(saveWith) {
        //data.rights = props.RolesReducer?.selected;
        //saveWith = false;
    }
    props.onSaveHandler(data);
      
    return false;
  };

    const onSaveRoleHandler = (data) => {
        return false;
        };
        
  return (
    <>


    <div className="px-4 sm:px-6 lg:px-8">

    <div>
      <div className="sm:hidden">
        <label htmlFor="tabs" className="sr-only">
          Select a tab
        </label>
        {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
        <select
          id="tabs"
          name="tabs"
          defaultValue={tabs.find((tab) => tab.current).name}
          className="block w-full rounded-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500"
        >
          {tabs.map((tab) => (
            <option key={tab.name}>{tab.name}</option>
          ))}
        </select>
      </div>
      <div className="hidden sm:block">
        <div className="border-b border-gray-200">
          <nav aria-label="Tabs" className="-mb-px flex space-x-8">
            {tabs.map((tab) => (
              <a
                key={tab.name}
                href={tab.href}
                onClick={() => setTab(tab.tabId)}
                aria-current={tab.current ? 'page' : undefined}
                className={classNames(
                  tab.tabId == selectedTab
                    ? 'border-indigo-500 text-indigo-600'
                    : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                  'group inline-flex items-center border-b-2 px-1 py-4 text-sm font-medium',
                )}
              >
                <tab.icon
                  aria-hidden="true"
                  className={classNames(
                    tab.tabId == selectedTab ? 'text-indigo-500' : 'text-gray-400 group-hover:text-gray-500',
                    '-ml-0.5 mr-2 h-5 w-5',
                  )}
                />
                <span>{tab.name}</span>
              </a>
            ))}
          </nav>
        </div>
      </div>
    </div>
    
    <div className="space-y-10 divide-y divide-gray-900/10">
      <div className="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-1">
       <form className="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2" onSubmit={handleSubmit(onSubmit)}>

                  <input
                    id="key"
                    type="hidden"
                    data-dashlane-disabled-on-field="true"
                    defaultValue={props?.selectedId}
                    key={(props && props.key) ?? null}
                    className="component block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
       
          <div className="flex items-center justify-end gap-x-6 border-t border-gray-900/10 px-4 py-4 sm:px-8">
            <Link to={(props.data && props.data.type == 1) ? "/team" : "/ext-team"} type="button" className="text-sm font-semibold leading-6 text-gray-900">
              Annuleren
            </Link>
            <button
              type="submit"
              className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Opslaan
            </button>
          </div>
    
{selectedTab == 1 &&
    <Pavillion {...props} register={register} onSaveHandler={onSaveWrapped} key={(props.data && props.data.key) ? props.data.key : "EM1"} setValue={setValue} getValues={getValues}/>
    }
          <div className="flex items-center justify-end gap-x-6 border-t border-gray-900/10 px-4 py-4 sm:px-8">
            <Link to="../" type="button" className="text-sm font-semibold leading-6 text-gray-900">
              Annuleren
            </Link>
            <button
              type="submit"
              className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Opslaan
            </button>
          </div>

        </form>
        
      </div>
      </div>

    </div>
    </>
      );
}
